export default function capitalize(string) {
  return string[0].toUpperCase().concat(string.slice(1));
}



// WEBPACK FOOTER //
// ./src/site-render/src/lib/capitalize.js